import { render, staticRenderFns } from "./CoveragePagePeriodSingle.vue?vue&type=template&id=b1c1baec"
import script from "./CoveragePagePeriodSingle.vue?vue&type=script&lang=js"
export * from "./CoveragePagePeriodSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports